import { useEffect, useState } from 'react';

const DEBUG_KEY = 'crowdfpl_debug';
const DEBUG_EVENT = 'crowdfpl-debug-change';

function getDebugFromStorage(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(DEBUG_KEY) === 'true';
}

export function useDebugMode(): boolean {
  const [enabled, setEnabled] = useState(getDebugFromStorage);

  useEffect(() => {
    const handler = () => setEnabled(getDebugFromStorage());
    window.addEventListener(DEBUG_EVENT, handler);
    return () => window.removeEventListener(DEBUG_EVENT, handler);
  }, []);

  return enabled;
}

/** Expose globally for console: __crowdfplDebug(true) to enable, __crowdfplDebug(false) to disable */
export function installDebugModeGlobal(): void {
  if (typeof window === 'undefined') return;
  (window as unknown as { __crowdfplDebug?: (on: boolean) => void }).__crowdfplDebug = (on: boolean) => {
    localStorage.setItem(DEBUG_KEY, on ? 'true' : 'false');
    window.dispatchEvent(new Event(DEBUG_EVENT));
  };
}
